// Twitter Consumer Key (API Key)
// https://apps.twitter.com/

// Owner: Ardis
export const oAuthTwitterApiKey = 'C4Rrs8A1OyxV1kvZU8iQmqSDR';

// Owner: Sasa
export const oAuthTwitterApiKeyDev = 'IcH5mYtZFqIyCkySJEKMLC0Pl';
